<template>
  <v-container class="container-card">
    <v-card>
      <LancamentoManual />
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import LancamentoManual from "@/components/comissao/deptoAdministrativo/LancamentoManual";
export default {
  components: {
    LancamentoManual
  },

  methods: {
    ...mapActions({
      fetchView: "sistema/fetchView"
    })
  },

  mounted() {
    this.fetchView("Lançamento Manual");
  }
};
</script>
